import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CategoriasService } from 'src/app/services/categorias.service';

interface FeatureItem {
  icon: string;
  title: string;
  text: string;
}

interface EcosystemNode {
  icon: string;
  name: string;
}

@Component({
  selector: 'app-who-we-are',
  templateUrl: './who-we-are.component.html',
  styleUrls: ['./who-we-are.component.scss']
})
export class WhoWeAreComponent implements OnInit {

  categorias: any[] = [];

  heroHighlights: FeatureItem[] = [
    { icon: 'fa-ticket', title: 'Miles de eventos', text: 'cada día' },
    { icon: 'fa-shield-check', title: 'Entradas seguras', text: 'y digitales' },
    { icon: 'fa-users', title: 'Organizadores', text: 'verificados' }
  ];

  organizerFeatures: FeatureItem[] = [
    { icon: 'fa-ticket', title: 'Venta de entradas', text: 'Vende entradas online, controla aforos y accede al dinero de forma segura.' },
    { icon: 'fa-file-lines', title: 'Página del evento', text: 'Crea páginas únicas, personalizadas y optimizadas para convertir.' },
    { icon: 'fa-bullhorn', title: 'Marketing', text: 'Envía campañas, cupones y recordatorios para llenar tus eventos.' },
    { icon: 'fa-user-group', title: 'Gestión de asistentes', text: 'Gestiona invitados, acreditaciones, listas y datos de asistentes.' },
    { icon: 'fa-chart-simple', title: 'Estadísticas', text: 'Analiza ventas, ocupación, conversiones y mucho más en tiempo real.' },
    { icon: 'fa-expand', title: 'Control de accesos', text: 'Escanea entradas, valida accesos y controla el aforo en tiempo real.' }
  ];

  controlHighlights: string[] = [
    'Ventas en tiempo real',
    'Aforo y asistentes',
    'Campañas y marketing',
    'Estadísticas detalladas',
    'Check-in y accesos'
  ];

  userFeatures: FeatureItem[] = [
    { icon: 'fa-bolt', title: 'Compra en un clic', text: 'Encuentra tu evento y consigue tu entrada en segundos.' },
    { icon: 'fa-mobile', title: 'Entradas digitales', text: 'Llévalas siempre contigo en el móvil. Sin imprimir.' },
    { icon: 'fa-location-dot', title: 'Eventos cerca de ti', text: 'Explora eventos por ubicación, fecha o categoría.' },
    { icon: 'fa-heart', title: 'Favoritos', text: 'Guarda tus eventos favoritos y crea tu lista personal.' },
    { icon: 'fa-bell', title: 'Avisos automáticos', text: 'Te avisamos cuando haya nuevos eventos que te interesen.' },
    { icon: 'fa-star', title: 'Recomendaciones', text: 'Descubre eventos pensados para ti según tus intereses.' }
  ];

  ecosystemNodes: EcosystemNode[] = [
    { icon: 'fa-landmark', name: 'Ayuntamientos' },
    { icon: 'fa-store', name: 'Comercios' },
    { icon: 'fa-user-group', name: 'Organizadores' },
    { icon: 'fa-heart', name: 'Asociaciones' },
    { icon: 'fa-people-group', name: 'Ciudadanos' }
  ];

  ecosystemBenefits: FeatureItem[] = [
    { icon: 'fa-eye', title: 'Más visibilidad', text: 'para tus eventos' },
    { icon: 'fa-user-plus', title: 'Más asistentes', text: 'para tu comunidad' },
    { icon: 'fa-masks-theater', title: 'Más cultura', text: 'en tu ciudad' },
    { icon: 'fa-link', title: 'Más conexión', text: 'entre personas' }
  ];

  // TODO: sustituir por los logos definitivos de organizadores/partners
  // Ficheros de assets/img/business. El orden es el de la fila de logos.
  partnerLogos: string[] = [
    '1ayuntamiento-logrono.png',
    '3Calahorra.png',
    '3ayuntamiento-de-miranda-de-ebro.png',
    '4teatro-logo-pie.png',
    '5club-balonmano-logrono.png',
    'Arnedo.png',
    'LaRioja_turismo.png',
    'Voces_de_la_lengua.png',
  ];

  constructor(private categoriasService: CategoriasService, private router: Router) { }

  ngOnInit(): void {
    this.categoriasService.getCategoriesWithEvents().subscribe({
      next: (val: any) => {
        this.categorias = (val?.data?.data ?? []).slice(0, 9);
      },
      error: () => this.categorias = []
    });
  }

  goToEvents() {
    this.router.navigate(['/results']);
  }

  goToOrganizer() {
    this.router.navigate(['/register/business']);
  }

}
